import { useMemo } from 'react';
import { ZodSchema } from 'zod';

export const maybeParseValues = <T>(
  schema: ZodSchema<T>,
  values: unknown[],
) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const value of values) {
    const result = schema.safeParse(value);
    if (result.success) {
      return result.data;
    }
  }
  return null;
};

export const useMaybeParseValues = <T>(
  schema: ZodSchema<T>,
  values: unknown[],
) => {
  return useMemo(() => maybeParseValues(schema, values), [schema, values]);
};
